import { roundFCFA } from '@shared/utils/round';

/**
 * Taxes sectorielles Gabon : TSAB (banques), CNCAS (culture), CGE (assurance).
 */
export class TaxesSectoriellesService {
  /** TSAB - Taxe Spéciale sur les Activités Bancaires (1 % du PNB). */
  static calculerTSAB(produit_net_bancaire: number): number {
    return roundFCFA(produit_net_bancaire * 0.01);
  }
  /** CNCAS - Centre National des Caisses pour les Activités Sportives et culturelles. */
  static calculerCNCAS(masse_salariale_culturelle: number): number {
    return roundFCFA(masse_salariale_culturelle * 0.005);
  }
  /** CGE - Contribution Générale sur les Etablissements d'assurance. */
  static calculerCGE(primes_emises: number): number {
    return roundFCFA(primes_emises * 0.025);
  }
}
